import React from 'react';
import styles from './UIGameEndRankedScreen.module.scss';
import { useUIGameEndContext } from '../../../contexts/UIGameEndContext.tsx';
import { MMRChange } from './MMRChange/index.ts';
import { RankedUserStateType } from '@colonist/leaderboard-types';
import { PlacementChange } from './PlacementChange/index.ts';
import { FADE_IN_ANIMATION_DELAYS } from '../constants.ts';
import { FadeInContainer } from '../../../common/FadeInContainer/index.ts';
export function UIGameEndRankedScreen({ onContinue, disableAnimation }) {
    const { currentPlayerRankedState } = useUIGameEndContext();
    const getRankChangeScreen = ()=>{
        const rankedType = currentPlayerRankedState === null || currentPlayerRankedState === void 0 ? void 0 : currentPlayerRankedState.type;
        if (rankedType === RankedUserStateType.Ranked) {
            return /*#__PURE__*/ React.createElement(MMRChange, {
                onContinue: onContinue,
                rankedState: currentPlayerRankedState,
                disableAnimation: disableAnimation
            });
        }
        if (rankedType === RankedUserStateType.RankedLocked || rankedType === RankedUserStateType.Placement) {
            return /*#__PURE__*/ React.createElement(PlacementChange, {
                onContinue: onContinue,
                rankedState: currentPlayerRankedState
            });
        }
        return null;
    };
    return /*#__PURE__*/ React.createElement(FadeInContainer, {
        animationDelayMs: FADE_IN_ANIMATION_DELAYS.content,
        animationDurationMs: FADE_IN_ANIMATION_DELAYS.transitionDuration,
        disableAnimation: disableAnimation,
        className: styles.container
    }, getRankChangeScreen());
}
